module.exports = __webpack_public_path__ + "static/media/shrimply-the-best.f471f02a.jpg";